// ----------------------------------------------------------------------
// <copyright file="Izenda.ExistingRelationshipPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Existing Relationship Popup component
 */
import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import RelationshipList from './Izenda.RelationshipList';
import DataGridSearch from 'share/components/controls/DataGrid/Izenda.DataGridSearch';
import localizer from 'share/localization/Izenda.Localizer';

@connect()
class ExistingRelationshipPopup extends Component {
  onClosePopup = () => {
    const { onAccept } = this.props;
    onAccept && onAccept();
  };

  onSearch = (searchProperty, searchText) => {
    const props = this.props;
    const store = props.store;
    const valManager = this.props.validation;

    return props.confirmDirtyForm(store.hasChange).then(
      function() {
        this.props.validation.reset();
        store.resetData();
        store.pageInfo.setSearchValues(searchProperty, searchText);

        props.updateLoading(true);
        props.loader.startLoading();
        return store
          .getRelationships()
          .then(props.updateLoading.bind(props, false))
          .finally(function() {
            props.loader.endLoading();
            valManager.validate();
          });
      }.bind(this)
    );
  };

  renderContent(store) {
      return (
        <div className='izenda-Wrapper'>
          <div className='izenda-Wrapper-header'>
            <div className='u_inlineBlock'>
              <DataGridSearch
                onSearch={this.onSearch}
                value={store.pageInfo.searchProperty}
                options={store.getCriteriaList()}
              />
            </div>
          </div>
          <div className='izenda-Wrapper-content'>
            {/* list of relationship*/}
            <RelationshipList store={store} width={this.props.width} isLoading={this.props.isLoading} isHideActionColumn />
          </div>
        </div>
      );
  }

  render() {
    const { store } = this.props;
    return (
      <Popup visible sizeClass="modal-relationship-size" type="border-none" onClosed={this.onClosePopup}>
        <Popup.Header title={localizer.getText('RELATIONSHIP_LABEL_EXISTING_RELATIONSHIPS')} />
        <Popup.Body>
          {this.renderContent(store)}
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton onClick={this.onClosePopup} label={localizer.getText('COMMON_LABEL_OK')}/>
        </Popup.Footer>
      </Popup>
    );
  }
}

export default ExistingRelationshipPopup;


// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/Relationship/Izenda.ExistingRelationshipPopup.js